import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminAmenityDto, AdminTagDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';

import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import { Row } from 'saladsoft-primitive';
import Text from 'components/commons/Text';
import TagMasterItem from 'components/pages/listings/TagMasterItem';
import { AmenityModel } from 'types/CommonTypes';
import AmenityForm from 'components/pages/amenity/AmenityForm';

const AmenitySettingPage = () => {
  const { uiStore } = useStoreWrapper();

  const [amenities, setAmenities] = useState<AdminAmenityDto[]>([]);



  const handleClickAmenity = (amenity?: AdminAmenityDto) => {
    uiStore?.modal.show({
      title: amenity?.id ? '편의시설 수정' : '편의시설 추가',
      style: { width: 800, maxHeight: '80%' },
      children: (
        <div style={{ padding: 20 }}>
          <AmenityForm
            amenity={amenity as AmenityModel}
            onSave={(amenity?: AmenityModel) => {
              fetchAmenities();
            }}
          />
        </div>
      ),
    });
  };

  const fetchAmenities = () => {
    ServiceHelper?.adminAmenityService?.getAmenities({ size: 1000 }).then((res) => {
      setAmenities(res.data);
    });
  }

  useEffect(() => {
    fetchAmenities();
  }, []);

  return (
    <PageLayout
      title="편의시설 설정"
      actionButton={<NewButton onClick={() => { handleClickAmenity() }}>편의시설 추가</NewButton>}
    >
      <InnerSection style={{ minHeight: 'unset' }}>
        <InnerGroup>
          <div>
            <Text type="H3">편의시설 목록</Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
              컨텐츠 등록을 위한 언어 설정이 가능합니다.
              <br />
              신규 언어가 추가되는 경우, 모든 컨텐츠에 추가된 언어를 입력해야 합니다.
              <br />
              <br /> 다만, 사이트에 표시되는 정적 언어(메뉴명, 타이틀 등)는 추가로 설정을 해야
              하므로 <br />
              개발사에 문의 해 주세요.
            </Text>
          </div>

          <Row gap={10} justifyContent="flex-start" flexWrap="wrap" marginTop={0}>
            {amenities?.map((amenity) => (
              <TagMasterItem key={amenity.id} tag={amenity} onClick={() => { handleClickAmenity(amenity) }} />
            ))}
          </Row>
        </InnerGroup>
      </InnerSection>
    </PageLayout>
  );
};

export default AmenitySettingPage;
